import Vue from 'vue'
import VueI18n from "../helpers/i18n"


  export interface IApiErrorData {
    code: string
    text: string | any
  }

  export interface IError {
  code?:string,
    status: 'ok' | 'error'
    text: string
  }

const errors: IApiErrorData[] = [
  { code: '0191', text: VueI18n.t('signin.error.0191') },
  { code: '0192', text: VueI18n.t('signin.error.0192') }
]

export default class ApiError {
  public static getError (code: string | number): IError {
    if (code !== '01') {
      const error = errors.find(error => error.code === String(code))

      if (error) {
        return { status: 'error', text: error.text, code:error.code}
      }

      return { status: 'error', text: 'Неизвестная ошибка, обратитесь к поддержке для получения информации по вашей проблеме...' }
    }

    return { status: 'error', text: 'ok' }
  }
}
